// import React, { useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { ROUTES } from '../../../core/data/routes';
// import { storageMgt } from '../../../core/utils/storage';
// import { useAuthStore } from '../store/authStore';
// import { FadeInAnimation } from '../../../core/components/ui';
// import splashArt from '../../../assets/images/splash.png';

// const SplashScreen: React.FC = () => {
//   const navigate = useNavigate();
//   const authStore = useAuthStore();

//   useEffect(() => {
//     const isAuth = storageMgt.isAuthenticated();
//     if (!isAuth) return;

//     let cancelled = false;
//     (async () => {
//       const user = storageMgt.getUser();
//       if (!user?.id) {
//         if (!cancelled) navigate(ROUTES.LOGIN, { replace: true });
//         return;
//       }
//       try {
//         const hasPrefs = await authStore.checkPrefs(user.id);
//         if (cancelled) return;
//         if (hasPrefs) {
//           navigate(ROUTES.INDEX, { replace: true });
//         } else {
//           navigate(ROUTES.PREFERENCE, { replace: true });
//         }
//       } catch {
//         if (!cancelled) navigate(ROUTES.LOGIN, { replace: true });
//       }
//     })();

//     return () => {
//       cancelled = true;
//     };
//   }, [navigate, authStore]);

//   const goToLogin = () => {
//     navigate(ROUTES.LOGIN);
//   };

//   return (
//     <div className="splash-page">
//       <div aria-hidden style={{ height: 'env(safe-area-inset-top, 0px)', minHeight: 8 }} />

//       <div style={{
//         flex: 1,
//         display: 'flex',
//         flexDirection: 'column',
//         alignItems: 'center',
//         justifyContent: 'center',
//         gap: 'clamp(12px, 3vw, 22px)',
//         width: '100%',
//       }}>
//         <FadeInAnimation delay={0}>
//           <img
//             src={splashArt}
//             alt=""
//             className="splash-hero-img"
//           />
//         </FadeInAnimation>

//         <FadeInAnimation delay={0.35}>
//           <h1 style={{
//             fontSize: 'clamp(22px, 5.5vw, 28px)',
//             fontWeight: 700,
//             color: '#F8FAFC',
//             textAlign: 'center',
//             lineHeight: 1.25,
//             padding: '0 8px',
//             maxWidth: 360,
//           }}>
//             It&apos;s ok not to be ok
//           </h1>
//         </FadeInAnimation>

//         <FadeInAnimation delay={0.65}>
//           <p style={{
//             fontSize: 'clamp(17px, 4.2vw, 20px)',
//             fontWeight: 500,
//             color: 'var(--color-splash-gold)',
//             textAlign: 'center',
//             padding: '0 8px',
//           }}>
//             Help is a click away
//           </p>
//         </FadeInAnimation>

//         <FadeInAnimation delay={0.95} style={{ width: '100%', maxWidth: 320, marginTop: 8 }}>
//           <button
//             type="button"
//             onClick={goToLogin}
//             style={{
//               width: '100%',
//               height: 52,
//               borderRadius: 14,
//               background: '#F8FAFC',
//               color: 'var(--color-primary)',
//               fontWeight: 700,
//               fontSize: 16,
//               boxShadow: '0 4px 16px rgba(0,0,0,0.2)',
//             }}
//           >
//             Get Started
//           </button>
//         </FadeInAnimation>
//       </div>

//       <FadeInAnimation delay={1.15} style={{ width: '100%', maxWidth: 400 }}>
//         <footer style={{ textAlign: 'center', paddingBottom: 4 }}>
//           <hr className="splash-divider" />
//           <div style={{ fontSize: 15, color: '#F8FAFC', fontWeight: 400 }}>
//             {process.env.REACT_APP_VERSION || '2.0.0'}
//           </div>
//           <div style={{ fontSize: 15, color: '#F8FAFC', fontWeight: 400, marginTop: 8 }}>
//             Powered by{' '}
//             <span style={{ fontWeight: 700, color: 'var(--color-splash-gold)' }}>Casantey</span>
//           </div>
//         </footer>
//       </FadeInAnimation>
//     </div>
//   );
// };

// export default SplashScreen;
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../../core/data/routes';
import { storageMgt } from '../../../core/utils/storage';
import { useAuthStore } from '../store/authStore';
import { FadeInAnimation } from '../../../core/components/ui';
import splashArt from '../../../assets/images/splash.png';

const SplashScreen: React.FC = () => {
  const navigate = useNavigate();
  const authStore = useAuthStore();

  useEffect(() => {
    const isAuth = storageMgt.isAuthenticated();
    if (!isAuth) return;

    let cancelled = false;

    (async () => {
      const user = storageMgt.getUser();

      if (!user?.id) {
        if (!cancelled) {
          navigate(ROUTES.LOGIN, { replace: true });
        }
        return;
      }

      try {
        const hasPrefs = await authStore.checkPrefs(user.id);

        if (cancelled) return;

        if (hasPrefs) {
          navigate(ROUTES.INDEX, { replace: true });
        } else {
          navigate(ROUTES.PREFERENCE, { replace: true });
        }
      } catch {
        if (!cancelled) {
          navigate(ROUTES.LOGIN, { replace: true });
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [navigate, authStore]);

  const goToLogin = () => {
    navigate(ROUTES.LOGIN);
  };

  return (
    <div className="page splash-page">
      <div
        aria-hidden
        style={{
          height: 'env(safe-area-inset-top, 0px)',
          minHeight: 8,
        }}
      />

      <div className="splash-content">
        <FadeInAnimation delay={0}>
          <img
            src={splashArt}
            alt=""
            className="splash-hero-img"
          />
        </FadeInAnimation>

        <FadeInAnimation delay={0.35}>
          <h1 className="splash-title">
            It&apos;s ok not to be ok
          </h1>
        </FadeInAnimation>

        <FadeInAnimation delay={0.65}>
          <p className="splash-subtitle">
            Help is a click away
          </p>
        </FadeInAnimation>

        {/* <FadeInAnimation
          delay={0.95}
          style={{
            width: '100%',
            maxWidth: 320,
            marginTop: 8,
          }}
        >
          <button
            type="button"
            onClick={goToLogin}
            className="splash-button"
          >
            Get Started
          </button>
        </FadeInAnimation> */}
        <FadeInAnimation
  delay={0.95}
  style={{
    width: '100%',
    maxWidth: 320,
    marginTop: 8,
  }}
>
  <button
    type="button"
    onClick={goToLogin}
    className="btn-gradient"
  >
    Get Started
  </button>
</FadeInAnimation>
      </div>

      <FadeInAnimation
        delay={1.15}
        style={{
          width: '100%',
          maxWidth: 400,
        }}
      >
        <footer className="splash-footer">
          <hr className="splash-divider" />

          <div className="splash-version">
            {process.env.REACT_APP_VERSION || '2.0.0'}
          </div>

          <div className="splash-powered">
            Powered by{' '}
            <span className="splash-company">
              Casantey
            </span>
          </div>
        </footer>
      </FadeInAnimation>
    </div>
  );
};

export default SplashScreen;